import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { RmEvaluation } from "./rm-evaluation.entity";

@Entity('rm_evaluation_samples')
export class RmEvaluationSamples{

    @PrimaryGeneratedColumn('increment', {name: 'rm_evaluation_sample_id'})
    rmEvaluationSampleId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'rm_evaluation_id'
    })
    rmEvaluationId: number;

    @Column({
        nullable: false,
        name: 'time'
    })
    time: Date;
    

    @Column({
        type: 'int',
        nullable: false,
        name: 'sample_no'
    })
    sampleNo:number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'species'
    })
    species: number;

    
    @Column({
        type: 'float',
        nullable: false,
        name: 'temperature'
    })
    temperature: number;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "general_appearance"
    })
    generalAppearance: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "general_odour"
    })
    generalOdour: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "freshness"
    })
    freshness: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "dehydration"
    })
    dehydration: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "discolouration"
    })
    discolouration: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "deterioration"
    })
    deterioration: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "black_Spot_or_tail"
    })
    blackSpotOrTail: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "loose_shells"
    })
    looseShells: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "broken_or_damaged_Pieces"
    })
    brokenOrDamagedPcs: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "fungal_growth"
    })
    fungalGrowth: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "soft_pieces"
    })
    softSpecies: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "drooping_head"
    })
    droopingHead: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "foreign_matter"
    })
    foreignMatter: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "sulphite_kit"
    })
    sulphiteKit: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "pests"
    })
    pests: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "muddy_odour"
    })
    muddyOdour: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "cooked_texture"
    })
    cookedTexture: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "cooked_flavor"
    })
    cookedFlavor: string;

    @Column("varchar", {
        nullable: false,
        length: 10,
        name: "parasite"
    })
    parasite: string;    

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    
    @ManyToOne(type => RmEvaluation, rmEval => rmEval.RmEvalSamplesInfo, {nullable: false})
    @JoinColumn({name: 'rm_evaluation_id'})
    rmEvaluationInfo: RmEvaluation[];
}